module.exports = __webpack_public_path__ + "static/media/google_logo.a3ba1b6c.png";